'use strict';

exports.__esModule = true;

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

exports.default = reducer;
exports.auth = auth;
exports.checkAllowNum = checkAllowNum;
exports.sendOnlineRequest = sendOnlineRequest;

var _CookieUtil = require('../util/CookieUtil');

var _CookieUtil2 = _interopRequireDefault(_CookieUtil);

var _reactRouter = require('react-router');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var t = {
    AUTH: '/auth/AUTH',
    AUTH_SUCCESS: '/auth/AUTH_SUCCESS',
    AUTH_FAIL: '/auth/AUTH_FAIL',

    SEND_ONLINE_REQUEST: '/auth/SEND_ONLINE_REQUEST',
    SEND_ONLINE_REQUEST_SUCCESS: '/auth/SEND_ONLINE_REQUEST_SUCCESS',
    SEND_ONLINE_REQUEST_FAIL: '/auth/SEND_ONLINE_REQUEST_FAIL',

    CHECK_ALLOW_NUM: '/auth/CHECK_ALLOW_NUM',
    CHECK_ALLOW_NUM_SUCCESS: '/auth/CHECK_ALLOW_NUM_SUCCESS',
    CHECK_ALLOW_NUM_FAIL: '/auth/CHECK_ALLOW_NUM_FAIL'
};

var initialState = {
    seniorSchoolName: '',
    qrCode: '',
    contactInformation: ''
};

function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    switch (action.type) {
        case t.AUTH_SUCCESS:
            if (action.result.data.success) {
                return _extends({}, state, {
                    seniorSchoolName: action.result.data.data.seniorSchoolName,
                    qrCode: action.result.data.data.qrCode ? action.result.data.data.qrCode : 'https://xgkstatic.microyan.com/bp/default.png'
                });
            } else {
                return state;
            }
        case t.CHECK_ALLOW_NUM_SUCCESS:
            if (action.result.data.success) {
                return _extends({}, state, {
                    contactInformation: action.result.data.data.contactInformation
                });
            }
        default:
            return state;
    }
}

function auth(ssid, type, callback) {
    return {
        types: [t.AUTH, t.AUTH_SUCCESS, t.AUTH_FAIL],
        promise: function () {
            function promise(client) {
                return client.get('/api/bp/auth?ssid=' + ssid + (type ? '&t=' + type : ''));
            }

            return promise;
        }(),
        afterSuccess: function () {
            function afterSuccess(dispatch, getState, result) {
                if (callback && result.data.success) {
                    callback(result.data.data.sessionId, ssid);
                }
                if (result.data.success) {
                    _CookieUtil2.default.set("ssid", ssid);
                } else {
                    _reactRouter.browserHistory.push('/403');
                }
            }

            return afterSuccess;
        }(),
        afterFail: function () {
            function afterFail() {
                _reactRouter.browserHistory.push('/403');
            }

            return afterFail;
        }()
    };
}

function checkAllowNum(id, ssid) {
    var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

    return {
        types: [t.CHECK_ALLOW_NUM, t.CHECK_ALLOW_NUM_SUCCESS, t.CHECK_ALLOW_NUM_FAIL],
        promise: function () {
            function promise(client) {
                return client.post('/api/bp/check', { 'mac': id, 'ssid': ssid, 'type': type });
            }

            return promise;
        }(),
        afterSuccess: function () {
            function afterSuccess(dispatch, getState, result) {
                if (result.data.success && !result.data.data.accessRight) {
                    _reactRouter.browserHistory.push('/overPaid');
                }
            }

            return afterSuccess;
        }()
    };
}

function sendOnlineRequest(id, ssid) {
    var type = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;

    return {
        types: [t.SEND_ONLINE_REQUEST, t.SEND_ONLINE_REQUEST_SUCCESS, t.SEND_ONLINE_REQUEST_FAIL],
        promise: function () {
            function promise(client) {
                return client.post('/api/bp/online', { 'mac': id, 'ssid': ssid, 'type': type });
            }

            return promise;
        }()
    };
}


//////////////////
// WEBPACK FOOTER
// ./src/reducers/auth.js
// module id = 502
// module chunks = 0